import { AutogenModelOrderHistType, AutogenRowOrderHistType } from "./autogen/AutogenModelOrderHistType";

export class ModelOrderHistType extends AutogenModelOrderHistType<RowOrderHistType> {
    constructor() {
        super(RowOrderHistType);
    }
}

export class RowOrderHistType extends AutogenRowOrderHistType {
}